<template>
    <div>
        <v-card class="p-3">
            <div class="d-flex justify-content-between">
                <div class="mt-3" v-if="entity === null">
                    <h6>
                        <v-icon left>work_off</v-icon>
                        Aucune entreprise gestionnaire définie
                    </h6>
                </div>

                <div class="mt-3" v-else>
                        <router-link :to="'/entity/' + encodeUri(entity.id)">
                            <v-icon left class="pb-1">work_outline</v-icon>
                            <span class="font-weight-bold h6">{{ entity.name }}</span>
                        </router-link>
                </div>

                <div class="d-flex justify-content-between gap-10">
                    <v-btn outlined class="custom-button-primary"
                           style="height: 36px;min-width: 42px;padding: 0"
                           @click="prepareEntityAssociation"
                    >
                        <v-icon>link</v-icon>
                    </v-btn>
                </div>
            </div>
        </v-card>

        <v-dialog v-model="associateEntityModal" persistent max-width="600px">
            <v-card id="edit-tags-card">
                <v-card-title>
                    <span class="headline">Associer une entreprise</span>
                </v-card-title>

                <v-card-text>
                    <v-combobox outlined chips small-chips :items="accountSitEntities" v-model="selectedEntity"
                                item-text="name" deletable-chips return-object>
                    </v-combobox>

                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="closeModal">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary"
                               @click="updateEntityAssociation" v-if="!hasEntity">
                            Associer
                        </v-btn>
                        <v-btn class="default-button custom-button-primary"
                               @click="updateEntityAssociation" v-else>
                            Modifier
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"
export default {
    name: "EntityBloc",
    props: [
      'providerId',
      'entity',
    ],
    data() {
        return {
            accountSitEntities: [],
            associateEntityModal: false,
            selectedEntity: null,
            hasEntity: false
        }
    },
    methods: {
        getAccountEntities() {
            this.$http.get("auth/sit-entity/light-account-sit-entities/" + this.account.id).then(res => {
                this.accountSitEntities = res.body.data.sitEntities
            })
        },
        updateEntityAssociation()
        {
            this.$global.loading = true

            let entityId = this.selectedEntity ? this.selectedEntity.id : null
            let payload = {
                providerId: this.providerId,
                sitEntityId: entityId
            }

            this.$http.put("auth/sit-entity/provider", payload).then(res => {
                this.closeModal()
                this.$global.$emit("reload-summary")
            })
        },
        encodeUri(id) {
            return btoa(id)
        },
        prepareEntityAssociation() {
            this.selectedEntity = this.entity
            this.associateEntityModal = true
        },
        closeModal() {
            this.selectedEntity = null
            this.associateEntityModal = false
        }
    },
    computed: {
        ...mapState("account", ["account"]),
    },
    created() {
        this.getAccountEntities()

        this.hasEntity = this.entity !== null
    }
}
</script>